module.exports = __webpack_public_path__ + "static/media/about-map.f0cd30db.png";